import i18next from 'i18next';

i18next.addResources('es_CL', 'CardCodeForm', {
  cardCodeLabel: 'Ingresa el código de seguridad de tu tarjeta (CVC)',
  cardCodePlaceholder: 'CVC',
  invalidCardCode: 'El CVC ingresado es inválido'
});
